import * as React from 'react';
import * as Icons from './Icons';

interface ITooltipIconProps {
  isLoading?: boolean;
  className?: string;
  type?: 'info' | 'warning' | 'error' | 'success' | 'loading';
  width?: string;
  positionX?: 'left' | 'right' | 'center';
  positionY?: 'top' | 'bottom';
  secondary?: boolean;
  text: React.ReactNode;
}

export const TooltipIcon = ({
  isLoading = false,
  className = '',
  width = 'w-32',
  positionX = 'right',
  positionY = 'bottom',
  type = 'info',
  secondary = false,
  text,
}: ITooltipIconProps) => (
  <div className={`inline-block group relative ${className}`}>
    {type === 'info' && <Icons.Info color={secondary ? '#fff' : 'primary'} />}
    {type === 'warning' && <Icons.Warning />}
    {type === 'error' && <Icons.Error />}
    {type === 'success' && <Icons.Success />}
    {type === 'loading' && (
      <Icons.Loading className={isLoading ? 'loader' : ''} />
    )}
    <span
      className={`tooltip tooltip--${positionY} tooltip--${positionX} block absolute text-black text-center z-30 px-3 py-2 border shadow-md hidden group-hover:block ${
        secondary
          ? 'tooltip-secondary bg-grey border-white'
          : 'bg-white border-grey'
      } ${width}`}
    >
      {text}
    </span>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/TooltipIcon.tsx